__turbopack_context__.v({
  "component": "style-module-scss-module__RftzXq__component",
  "content": "style-module-scss-module__RftzXq__content",
  "message": "style-module-scss-module__RftzXq__message",
});
